import { render, staticRenderFns } from "./car-buy-upper-buttons.vue?vue&type=template&id=13571206&"
import script from "./car-buy-upper-buttons.vue?vue&type=script&lang=js&"
export * from "./car-buy-upper-buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports